const LegalEntityHeaders = {
  validHeader: {
    'Legal Entity Code*': 'legal_entity_code',
    'Freight Invoice Company Name*': 'company_name',
    'Freight Invoice Company GSTIN*': 'gstin',
    'Freight Invoice Company Address*': 'address',
    'Freight Invoice Company City*': 'city',
    'Freight Invoice Company State*': 'state',
    'Freight Invoice Company Pincode*': 'pincode',
    'LR Document Company Name*': 'lr_document_company_name',
    'LR Document Company GSTIN*': 'lr_document_company_gstin',
    'LR Document Company Address*': 'lr_document_company_address',
    'LR Document Company City*': 'lr_document_company_city',
    'LR Document Company State*': 'lr_document_company_state',
    'LR Document Company Pincode*': 'lr_document_company_pincode',
  },
};

module.exports = {
  LegalEntityHeaders,
};
